/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2572
 */

var r = require(/* 771 */"../../../../../797/101/2466/2477/2536/771/index")
var i = require(/* 538 */"../../../../../797/101/2466/2467/538")
module.exports = function (e) {
  return i(e) && r(e)
}
